import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { traceRouting } from '../../utils/routingDebug';

/**
 * #1298 — escucha `billing:trial-expired` (lo emiten apiClient y el XHR de adjuntos al
 * recibir un 402 `trial_expired`) y lleva a /billing/required, donde el usuario puede
 * elegir plan y pagar. Antes de esto se enteraba solo al recargar.
 *
 * Montado una vez en App.jsx, junto a <AccountStatusListener />. No pinta nada. Misma
 * doctrina que ese listener: navegación SPA, sin `window.location.href`.
 */
const TrialExpiredListener = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handler = (event) => {
      if (location.pathname === '/billing/required') return;
      traceRouting('TrialExpiredListener', 'Navigate', {
        to: '/billing/required',
        reason: 'trial_expired',
        endpoint: event?.detail?.endpoint,
      });
      navigate('/billing/required', { replace: true });
    };

    window.addEventListener('billing:trial-expired', handler);
    return () => window.removeEventListener('billing:trial-expired', handler);
  }, [navigate, location.pathname]);

  return null;
};

export default TrialExpiredListener;
